module.exports = __webpack_public_path__ + "img/cun1.ad15f9b4.jpg";